var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('asc-fault-monitor-detail-item-header',{attrs:{"item":_vm.item}}),_c('div',{staticClass:"asc-fault-monitor-detail--container"},[_c('asc-fault-monitor-detail-item-detail',{attrs:{"item":_vm.item}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }